import { Route, Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';

const protectedRoute = (
  path: string,
  loader: Route['loadComponent'],
  data?: Record<string, string>,
): Route => ({
  path,
  loadComponent: loader,
  canActivate: [authGuard],
  data,
});

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login.component').then((m) => m.LoginComponent),
  },
  protectedRoute('dashboard', () =>
    import('./pages/dashboard.component').then((m) => m.DashboardComponent),
  ),
  protectedRoute('shipments', () =>
    import('./pages/shipments.component').then((m) => m.ShipmentsComponent),
  ),
  protectedRoute('shipments/:shipmentId', () =>
    import('./pages/shipment-detail.component').then((m) => m.ShipmentDetailComponent),
  ),
  protectedRoute('support', () =>
    import('./pages/support-center.component').then((m) => m.SupportCenterComponent),
  ),
  protectedRoute('help', () =>
    import('./pages/help-center.component').then((m) => m.HelpCenterComponent),
  ),
  protectedRoute(
    'clearance',
    () => import('./pages/list-page.component').then((m) => m.ListPageComponent),
    { title: 'Clearance', endpoint: 'clearance', kind: 'clearance' },
  ),
  protectedRoute(
    'container-tracking',
    () => import('./pages/list-page.component').then((m) => m.ListPageComponent),
    { title: 'Container Tracking', endpoint: 'container-tracking', kind: 'container' },
  ),
  protectedRoute(
    'order-releases',
    () => import('./pages/list-page.component').then((m) => m.ListPageComponent),
    { title: 'Order Releases', endpoint: 'order-releases', kind: 'releases' },
  ),
  protectedRoute('quotations', () =>
    import('./pages/quotations.component').then((m) => m.QuotationsComponent),
  ),
  protectedRoute('quotations/:quotationId', () =>
    import('./pages/quotation-detail.component').then((m) => m.QuotationDetailComponent),
  ),
  protectedRoute(
    'posm',
    () => import('./pages/posm-projects.component').then((m) => m.PosmProjectsComponent),
    { title: 'POSM Projects' },
  ),
  protectedRoute(
    'posm/:projectId',
    () =>
      import('./pages/posm-project-workspace.component').then(
        (m) => m.PosmProjectWorkspaceComponent,
      ),
    { title: 'POSM Project Workspace' },
  ),
  protectedRoute('warehousing/items/:itemId', () =>
    import('./pages/warehouse-item-detail.component').then((m) => m.WarehouseItemDetailComponent),
  ),
  protectedRoute('warehousing', () =>
    import('./pages/warehouse-stock.component').then((m) => m.WarehouseStockComponent),
  ),
  protectedRoute('warehousing/ledger', () =>
    import('./pages/warehouse-ledger.component').then((m) => m.WarehouseLedgerComponent),
  ),
  { path: 'finance', redirectTo: 'finance/statements', pathMatch: 'full' },
  protectedRoute(
    'finance/statements',
    () => import('./pages/list-page.component').then((m) => m.ListPageComponent),
    { title: 'Financial Statements', endpoint: 'finance/statements', kind: 'statements' },
  ),
  protectedRoute(
    'finance/invoices',
    () => import('./pages/list-page.component').then((m) => m.ListPageComponent),
    { title: 'Invoices', endpoint: 'finance/invoices', kind: 'invoices' },
  ),
  protectedRoute(
    'finance/bills',
    () => import('./pages/list-page.component').then((m) => m.ListPageComponent),
    { title: 'Bills', endpoint: 'finance/bills', kind: 'bills' },
  ),
  protectedRoute(
    'finance/receipts',
    () => import('./pages/list-page.component').then((m) => m.ListPageComponent),
    { title: 'Receipts', endpoint: 'finance/receipts', kind: 'receipts' },
  ),
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: 'dashboard' },
];
